import { useQuery } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';

import {
  GetLoyaltyPromoKeyOptionsParams,
  PromoLoyaltyCustomRulePresented,
  getLoyaltyPromoKeyOptions,
} from '~/services/PromoService';

export type UsePromoLoyaltyPromoKeyOptionsFormValues = GetLoyaltyPromoKeyOptionsParams;

export type UsePromoLoyaltyPromoKeyOptionsResult = {
  form: ReturnType<typeof useForm<UsePromoLoyaltyPromoKeyOptionsFormValues>>;
  data: PromoLoyaltyCustomRulePresented[] | undefined;
  isLoading: boolean;
  total: number;
  error: Error | null;
  refetch: () => void;
};

export function usePromoLoyaltyPromoKeyOptions(
  defaultValues?: Partial<UsePromoLoyaltyPromoKeyOptionsFormValues>,
): UsePromoLoyaltyPromoKeyOptionsResult {
  const form = useForm<UsePromoLoyaltyPromoKeyOptionsFormValues>({
    defaultValues: defaultValues || {},
  });

  const formValues = form.watch();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['loyaltyPromoKeyOptions', formValues],
    queryFn: async ({ signal }) => {
      const response = await getLoyaltyPromoKeyOptions(formValues);
      return response.result;
    },
    enabled: true,
  });

  return {
    form,
    data: data?.loyaltyPromoKeyOptions,
    total: data?.total,
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
